import React, { useState } from 'react';
import './Modal.css';
import './SaveAnalysisModal.css';

const SaveAndExploreModal = ({ isOpen, onClose, onSaveAndExplore, loading }) => {
  const [analysisName, setAnalysisName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!analysisName.trim()) {
      setError('Please enter an analysis name');
      return;
    }

    onSaveAndExplore(analysisName.trim());
  };

  const handleClose = () => {
    setAnalysisName('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay save-analysis-modal" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Save Analysis and Explore</h2>
          <button className="modal-close" onClick={handleClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {loading ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem 0'
              }}>
                <div className="loading-spinner-small"></div>
                <p style={{ marginTop: '1rem', color: '#667eea', fontWeight: '500' }}>
                  Preparing Analysis...
                </p>
              </div>
            ) : (
              <>
                <p className="modal-description">
                  Give this location a name. The analysis will be saved and you can explore the origins of visitors.
                </p>

                <div className="form-group">
                  <label htmlFor="analysis-name">Analysis Name</label>
                  <input
                    id="analysis-name"
                    type="text"
                    value={analysisName}
                    onChange={(e) => {
                      setAnalysisName(e.target.value);
                      setError('');
                    }}
                    placeholder="e.g., Edinburgh City Centre July 2025"
                    maxLength={255}
                    disabled={loading}
                    autoFocus
                  />
                  {error && <div className="form-error">{error}</div>}
                </div>
              </>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
            >
              {loading ? 'Preparing Analysis...' : 'Save and Explore Origins'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SaveAndExploreModal;
